import {
  CalculationFactor,
  IntervalFrequencyEnum,
  ResourceFactor,
} from 'mapistry-shared';

/**
 * @deprecated Use IntervalFrequencyEnum from mapistry-shared directly instead
 */
export type Frequency = IntervalFrequencyEnum;

export type Factor = ResourceFactor | CalculationFactor;

// any object for now
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type NotesData = { [key: string]: any };

// UI centric types
export type ChartType = 'bar' | 'line';

export type SingleOption<T> = {
  value: T;
  label: string;
};

export type SubOptions<T> = { options: SingleOption<T>[] };

export type Option<T> = SingleOption<T> | SubOptions<T>;

export function isSingleOption<T>(
  option: Option<T>,
): option is SingleOption<T> {
  return (option as SingleOption<T>).value !== undefined;
}

export function isSubOptions<T>(option: Option<T>): option is SubOptions<T> {
  return (option as SubOptions<T>).options !== undefined;
}

export type DocumentType = {
  description: string;
  fileId: string;
  folderSlug: string;
  id: string;
  mimeType: string;
  name: string;
  permissions: {
    hasDeletePermission: boolean;
  };
  processing?: boolean;
  projectId: string;
  src: string;
};
